import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility.js";
import issueService from "./report-service.js";
import commonAPIService from "../../common/js/common-api-service";
import HtmlRichEditorComp from "../../common/html-rich-editor-comp.vue";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    actionList: [],
    mainPage: "",
    favouriteList: [],
    pageUrl: "",
    subPage: "",
    showAdd: false,
    subPageUrl: "",
    backSlash: true,
    backSlashParent: true,
    issueId: "",
    searchTicket: "",
    issueTrackerData: [],
    issueType: "",
    selectedStatus: "",
    filesTable: [],
    newIssueTypeDialog: false,
    bugStatusList: [],
    totalRecords: 0,
    issueComments: "",
    updatedHistoryTable: [],
    newIssueType: "",
    issueTypeData: [],
    editIssueTypeDialog: false,
    editIssueTypeName: "",
    editIssueData: [],
    issueTypeDelDialog: false,
    deleteIssueData: [],
    issueTypeList: [],
    file: "",
    files: "",
    fileList: [],
    noFiles: true,
    dragging: false,
    selectedProject: 0,
    projectList: [],
    issueTypeHeader: [
      { text: "Issue Type", align: "start", value: "issue_type", class: "primary customwhite--text" },
      { text: "Actions", value: "actions", class: "primary customwhite--text" },
    ],
    statusMap: {
      New: { text: "New", class: "new" },
      Duplicate: { text: "Duplicate", class: "duplicate" },
      "In-Progress": { text: "In-Progress", class: "inprogress" },
      "Dev-Fixed": { text: "Dev-Fixed", class: "devfix" },
      "In-Testing": { text: "In-Testing", class: "intest" },
      Resolved: { text: "Resolved", class: "resolved" },
      Closed: { text: "Closed", class: "closed" },
      UserDeleted: { text: "UserDeleted", class: "userdelete" },
      default: { text: "Inactive", class: "inactive" },
    },
    updateHistoryHeader: [
      { text: "Status", align: "start", value: "status", class: "primary customwhite--text" },
      { text: "Updated Date", align: "start", value: "u_date_history", class: "primary customwhite--text" },
      { text: "Updated By", value: "u_by_history", class: "primary customwhite--text" },
      { text: "Comments", value: "comments", class: "primary customwhite--text" },
    ],
    required: [(v) => !!v || "Field is required"],
    max2000Rule: [(v) => (v || "").length <= 2000 || "Max Length of 2000 character", (v) => !!v || "Field is required"],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.mainPage = data?.mainPage;
    this.favouriteList = data?.favouriteList;
    this.pageUrl = data?.pageUrl;
    this.subPage = data?.subPage;
    this.showAdd = data?.showAdd;
    this.subPageUrl = data?.subPageUrl;
    this.appPageName = data?.appPageName;
    let actionData = await AddFavourite.getParentPageAction(this.userId, this.subPageUrl);
    this.actionList = actionData?.actionList;
    if (this.$route.params.issueId !== undefined) {
      this.issueId = atob(this.$route.params.issueId);
      this.getIssueStatusList();
      this.getIssueDetails();
    } else {
      this.$router.push(`/feedback-tracker`);
    }
  },
  methods: {
    //Reset function
    resetFunction() {
      this.searchTicket = "";
      this.issueTrackerData = [];
      this.issueType = "";
      this.selectedStatus = "";
      this.updatedHistoryTable = [];
      this.newIssueTypeDialog = false;
      this.bugStatusList = [];
      this.totalRecords = 0;
      this.issueComments = "";
      this.newIssueType = "";
      this.issueTypeData = [];
      this.editIssueData = [];
      this.issueTypeDelDialog = false;
      this.deleteIssueData = [];
      this.issueTypeList = [];
      this.file = "";
      this.files = "";
      this.fileList = [];
      this.selectedProject = 0;
      this.projectList = [];
      this.noFiles = true;
      this.dragging = false;
    },
    // Function to get CSS class of the text
    getStatusClass(status) {
      return this.statusMap[status]?.class || this.statusMap.default.class;
    },
    //Search ticket number
    async onSearch() {
      const ticket = this.searchTicket?.trim();
      if (!ticket) return;
      const searchData = await issueService.postIssueTracker(
        "post",
        {
          UserId: parseInt(this.userId),
          pass: 3,
        },
        false,
      );
      const foundTicket = searchData?.find((item) => item.ticket_number.toUpperCase() === ticket.toUpperCase());
      if (!foundTicket) {
        return this.$store.commit("ConfigModule/Alert", {
          type: "error",
          isShow: true,
          message: "No ticket found with this number.",
        });
      }

      this.$router.push({
        name: "feedbackTrackerDetails",
        params: {
          issueId: btoa(foundTicket.issue_id.toString()),
        },
      });
    },
    //Clear search ticket
    clearSearchTicket() {
      this.searchTicket = "";
    },
    //Change event of the upload
    onChange(e) {
      this.files = e.target.files || e.dataTransfer.files;
      if (!this.files.length) {
        this.dragging = false;
        return;
      } else {
        this.noFiles = false;
        if (this.files.length > 1) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Max 1 files can be uploaded.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.noFiles = true;
          this.dragging = false;
          this.files = "";
        }
        for (let i = 0; i < this.files.length; i++) {
          this.createFile(this.files[i]);
        }
      }
    },
    //Checking file details
    createFile(file) {
      if (file.size > 15000000) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "File size is more than 15MB",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.noFiles = true;
        this.dragging = false;
        return;
      }
      this.file = file;
      this.dragging = false;
      this.fileList.push(file);
    },
    //Removing dragged file
    removeFile(name) {
      this.fileList = this.fileList.filter((x) => x.name !== name);
      if (!this.fileList.length > 0) {
        this.noFiles = true;
        this.file = "";
        this.dragging = false;
      }
    },
    //Get Issue Details
    async getIssueDetails() {
      this.getIssueType();
      this.getProjectList();
      let detailsObj = {
        pass: 7,
        userId: 0,
        issue_id: parseInt(this.issueId),
      };
      let data = await issueService.postIssueTracker("post", detailsObj, false);
      const newArr = data.map((obj) => {
        return {
          ...obj,
          udate: Utility.displayDateFormat(obj.udate),
          cdate: Utility.displayDateFormat(obj.cdate),
          sch_completion_date: Utility.displayDateFormat(obj.sch_completion_date),
        };
      });
      this.issueTrackerData = newArr;
      this.issueType = data[0].issue_type_id;
      this.selectedStatus = parseInt(data[0].issue_status_id);
      this.selectedProject = parseInt(data[0]?.proj_key)
      if (data[0]?.issue_updates !== null) this.updatedHistoryTable = data[0]?.issue_updates;
      this.updatedHistoryTable.forEach((element) => {
        element.u_date_history = Utility.displayDateFormat(element.u_date_history);
      });
      if (data[0]?.file_details !== null) this.filesTable = data[0]?.file_details;
    },
    //Get Issue Types List
    async getIssueType() {
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 9,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.issueTypeList = data;
      }
    },
    //Get Project List
    async getProjectList() {
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 13,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.projectList = data;
      }
    },
    //Download file function
    async downloadFile(item) {
      let showMessage = true;
      let downloadLink = await issueService.getIssueImages("get", item, showMessage);
      if (downloadLink !== undefined && downloadLink !== null) {
        window.open(downloadLink, "_blank").focus();
      }
    },
    //Get Issue Types List for Data table
    async getIssueData() {
      let issueObj = {
        Pass: 1,
        issue_type_id: 0,
        issue_type: "",
        active: true,
      };
      let showMessage = false;
      let data = await issueService.postIssueType("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.issueTypeData = data;
      }
    },
    //Get Issue status list
    async getIssueStatusList() {
      this.bugStatusList = [];
      this.totalRecords = 0;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 4,
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
      this.bugStatusList = issueTrackerData;
    },
    //Close the popup
    closeDialog() {
      if (this.newIssueTypeDialog) {
        this.newIssueType = "";
        this.issueTypeData = [];
        this.editIssueData = [];
        this.deleteIssueData = [];
        this.$refs.newIssueTypeForm.resetValidation();
        this.newIssueTypeDialog = false;
      } else if (this.editIssueTypeDialog) {
        this.editIssueTypeDialog = false;
        this.editIssueTypeName = "";
        this.$refs.editIssueTypeNameForm.resetValidation();
      } else {
        this.updatedHistoryTable = [];
        this.filesTable = [];
        this.selectedStatus = "";
        this.issueComments = "";
        this.getIssueStatusList();
        this.getIssueDetails();
      }
    },
    //New Issue Type Name
    async submitNewIssue() {
      let issueObj = {
        Pass: 2,
        issue_type_id: 0,
        issue_type: this.newIssueType,
        active: true,
      };
      let showMessage = true;
      let data = await issueService.postIssueType("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.newIssueType = "";
        this.$refs.newIssueTypeForm.resetValidation();
        this.getIssueData();
      }
    },
    //Edit Issue Type button click
    editIssue(item) {
      this.editIssueData = [];
      this.editIssueData = item;
      this.editIssueTypeDialog = true;
      this.editIssueTypeName = item.issue_type;
    },
    //Delete Issue Type button click
    deleteIssue(item) {
      this.deleteIssueData = [];
      this.deleteIssueData = item;
      this.issueTypeDelDialog = true;
    },
    //Edit Issue Type Name
    async editIssueName() {
      if (this.$refs.editIssueTypeNameForm.validate()) {
        let issueObj = {
          Pass: 3,
          issue_type_id: this.editIssueData.issue_type_id == undefined ? this.issueTrackerData[0].issue_type_id : this.editIssueData.issue_type_id,
          issue_type: this.editIssueTypeName,
          active: true,
        };
        let showMessage = true;
        let data = await issueService.postIssueType("post", issueObj, showMessage);
        if (data !== null && data !== undefined && data.message !== "NA") {
          this.editIssueTypeDialog = false;
          this.editIssueData = [];
          this.getIssueData();
          if (this.newIssueTypeDialog) {
            this.$refs.newIssueTypeForm.resetValidation();
          }
        }
      }
    },
    //Delete Issue Type Name
    async deleteIssueType() {
      let issueObj = {
        Pass: 4,
        issue_type_id: this.deleteIssueData.issue_type_id,
        issue_type: this.deleteIssueData.issue_type,
        active: true,
      };
      let showMessage = false;
      let data = await issueService.postIssueType("post", issueObj, showMessage);
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.issueTypeDelDialog = false;
        this.deleteIssueData = [];
        this.getIssueData();
      }
    },
    //Submit Issue change status
    async submitIssueStatus() {
      if (this.$refs.submitStatusCheck.validate()) {
        if (this.file !== "") {
          const formData = new FormData();
          formData.append("files", this.fileList[0]);
          let issueObj = {
            UserId: parseInt(this.userId),
            pass: 5,
            issue_id: this.issueId,
            comments: this.issueComments,
            status: this.selectedStatus,
            issue_type_id: this.issueType,
            description: this.issueTrackerData[0]?.description,
            proj_key: parseInt(this.selectedProject)
          };
          let showMessage = true;
          let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
          if (issueTrackerData.Result[0]) {
            let uploadImage = await commonAPIService.postIssueImages("post", this.issueId, formData, showMessage);
            if (uploadImage !== undefined) {
              this.file = "";
              this.noFiles = true;
              this.closeDialog();
            }
          }
        } else {
          let issueObj = {
            UserId: parseInt(this.userId),
            pass: 5,
            issue_id: this.issueId,
            comments: this.issueComments,
            status: this.selectedStatus,
            issue_type_id: this.issueType,
            description: this.issueTrackerData[0]?.description,
            proj_key: parseInt(this.selectedProject)
          };
          let showMessage = true;
          let issueTrackerData = await issueService.postIssueTracker("post", issueObj, showMessage);
          if (issueTrackerData.Result[0]) {
            this.closeDialog();
          }
        }
      }
    },
    // Decode HTML entities
    decodeHtml(html) {
      if (!html) return "";
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    // To get the action List
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    HtmlRichEditorComp,
  },
};
